import { useState } from "react";
import { Link } from "react-router-dom";
import { KeyRound, MailCheck } from "lucide-react";
import { useTranslation, Trans } from "react-i18next";
import api, { formatApiError } from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="forgot-password-page" className="min-h-[80vh] flex items-center justify-center bg-slate-50 px-5 py-28">
      <Seo noindex title="Forgot Password | Belo Rentals" path="/forgot-password" />
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-card p-8">
          {sent ? (
            <div data-testid="forgot-sent" className="text-center">
              <span className="grid place-items-center w-14 h-14 rounded-full bg-green-100 text-green-600 mx-auto"><MailCheck size={28} /></span>
              <h1 className="font-heading text-2xl font-semibold text-slate-900 mt-5">{t("auth.checkEmail")}</h1>
              <p className="text-slate-500 text-sm mt-3"><Trans i18nKey="auth.checkEmailSub" values={{ email }} components={[<span className="font-medium text-slate-700" />]} /></p>
              <Link to="/login" className="inline-block mt-7 text-blue-600 font-semibold hover:underline">{t("auth.backToSignIn")}</Link>
            </div>
          ) : (
            <form onSubmit={submit} data-testid="forgot-form">
              <div className="flex items-center gap-3 text-slate-900 mb-2">
                <span className="grid place-items-center w-9 h-9 rounded-lg bg-blue-50 text-blue-600"><KeyRound size={18} /></span>
                <h1 className="font-heading text-2xl font-semibold">{t("auth.resetTitle")}</h1>
              </div>
              <p className="text-slate-500 text-sm mb-7">{t("auth.resetSub")}</p>
              {error && <div className="bg-red-50 border border-red-200 text-red-600 text-sm px-4 py-3 rounded-xl mb-6">{error}</div>}
              <span className="label-caps text-slate-400 block mb-2">{t("auth.email")}</span>
              <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="belo-input" placeholder="you@email.com" />
              <button type="submit" disabled={loading} data-testid="forgot-submit" className="mt-7 w-full bg-blue-600 text-white py-3.5 rounded-full font-semibold hover:bg-blue-700 transition-colors disabled:opacity-50">
                {loading ? t("auth.sending") : t("auth.sendResetLink")}
              </button>
              <p className="text-center text-sm text-slate-500 mt-6"><Link to="/login" className="text-blue-600 font-semibold hover:underline">{t("auth.backToSignIn")}</Link></p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
